import { Component, Input, OnInit } from '@angular/core';
import { EntryFeeInfo, RegularEntryFeeConfig } from 'src/app/services/rest-api/rest-api';

@Component({
  selector: 'libero-fees-entry-regular-config-dropdown',
  templateUrl: './fees-entry-regular-config-dropdown.component.html',
  styleUrl: './fees-entry-regular-config-dropdown.component.scss',
  standalone: false,
})
export class FeesEntryRegularConfigDropdownComponent implements OnInit {
  public toggled = false;
  @Input() public feeAmounts?: EntryFeeInfo;
  @Input() public feeConfig?: RegularEntryFeeConfig;
  @Input() public opfFeeImplVariant = '';
  @Input() public hasVat = false;

  public toggle(): void {
    this.toggled = !this.toggled;
  }

  public ngOnInit(): void {
    if (this.feeConfig)
      this.toggled = this.feeConfig.entryFee > 0
  }
}
